import React from 'react'

const ALIGNMENT = {
  LEFT: 'Left',
  CENTER: 'Center',
  RIGHT: 'Right',
}

const CardImage = ({
  image,
  alt,
  title,
  alignment = 'left',
  resolution = 'original',
  width = 'full',
  wrapperClassNames = '',
  classNames = '',
}) => {
  const imageWidth = width === 'auto' ? 'u-inlineBlock' : 'u-sizeFull'

  const getImageUrl = (imageSrc) => {
    switch (resolution) {
      case 'original':
        return imageSrc.getOriginal().getUrl()
      case 'xsmall':
        return imageSrc?.model?.data?.xsmall?.links?.site?.href || ''
      case 'small':
        return imageSrc?.model?.data?.small?.links?.site?.href || ''
      case 'medium':
        return imageSrc?.model?.data?.medium?.links?.site?.href || ''
      case 'large':
        return imageSrc?.model?.data?.large?.links?.site?.href || ''
      case 'xlarge':
        return imageSrc?.model?.data?.xlarge?.links?.site?.href || ''
      case 'xxlarge':
        return imageSrc?.model?.data?.xxlarge?.links?.site?.href || ''
      case 'thumbnail':
        return imageSrc.getThumbnail().getUrl()
      default:
        return imageSrc.getOriginal().getUrl()
    }
  }

  const imageAlignment =
    alignment === ALIGNMENT.LEFT
      ? 'u-flexAlignItemsStart'
      : alignment === ALIGNMENT.CENTER
        ? 'u-flexAlignItemsCenter'
        : alignment === ALIGNMENT.RIGHT
          ? 'u-flexAlignItemsEnd'
          : ''

  return (
    <div
      className={`CardImage ${wrapperClassNames} u-flex u-flexCol ${imageAlignment}`}
    >
      <img
        src={getImageUrl(image)}
        alt={alt || 'Card image'}
        aria-label={title}
        className={`${imageWidth} ${classNames}`}
      />
    </div>
  )
}

export default CardImage
